import { PropsWithChildren, ReactElement } from 'react';
import classNames from 'classnames';
import { Props } from './';
import './Title.scss';

export const Title = ({
  children,
  className,
  onClick,
  productUrl,
  title,
}: PropsWithChildren<Props>): ReactElement | null => {
  if (!title) {
    return null;
  }

  const rootClassName = classNames(
    'CartProduct-Title',
    {
      'CartProduct-TitleLink': !!productUrl,
    },
    className,
  );

  if (productUrl) {
    return (
      <a
        className={rootClassName}
        href={productUrl}
        onClick={onClick}
      >
        {title}
        {children}
      </a>
    );
  }

  return (
    <div className={rootClassName}>
      {title}
      {children}
    </div>
  );
};
